export interface ApiResponse<T> {
  // Base structure
  elements: number;
  first: boolean;
  items: T;
  last: boolean;
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;

  // Error structure
  message: string;
  stack: string;
  code: number;
}
